/**
 * @title   lastSearchHistory
 * @author  Malte Lauterbach
 * @type    controller
 * @desc    show last searches in suggest
 * @date    05.2016
 */
var lastSearchHistory = {
    container: $('#lastSearchHistory'),
    inputField: $('#dep'),
    filterBox: $('#filterBox'),
    searchHistory: {},
    cache: {},

    filterFromLastRequestsUsed: false,

    filterGroupsThatAreArrays: [
        'acrissDescriptions',
        'prestige',
        'supplier_rating',
        'offer_category',
        'add_insurances',
        'fuel_policy',
        'extras',
        'carclass_characteristics',
        'showOnlyProviders',
        'paymentMethods',
        'benchmark',
    ],

    init: function () {
        var history = this.getHistoryFromJson();
        if (history) {
            this.searchHistory = history;
            this.setEvents();
        }
    },

    getHistoryFromJson: function () {
        return JSON.parse(this.container.attr('data-list') || 'null');
    },

    setEvents: function () {
        var self = this;

        $('.delete-last-search').on('mousedown', function () {
            self.deleteLastSearch();
        });

        this.inputField.on('input focusin', function () {
            if (self.inputField.val().length === 0) {
                self.container.show();
            } else {
                self.container.hide();
            }
        });

        this.inputField.on('blur', function () {
            self.container.hide();
        });

        this.container.find('.last-search-entry').on('mousedown', function () {
            var id = $(this).attr('id').replace('lastSearchEntry', '');

            var track = new actionTracking({
                acTrAc: 'clicked_searchHistory',
                acTrLa: 'entry',
            });
            track.push();

            self.processLastRequest(self.searchHistory[id]);
            self.manageBackgroundImage(
                self.searchHistory[id].dep_name,
                self.searchHistory[id].dep_airport_code
            );
        });

        this.inputField.trigger('focus');
    },

    processLastRequest: function (history) {
        $('#dep').val(history.dep_name);
        $('#depAirport').val(history.dep_airport_code);

        $('#depDate').val(this.formatDate(history.dep_date));
        $('#depTime').val(this.formatTime(history.dep_date));
        $('#destDate').val(this.formatDate(history.dest_date));
        $('#destTime').val(this.formatTime(history.dest_date));

        var destSelect = $('#destSelect');

        if (history.dep_airport_code !== history.dest_airport_code) {
            destSelect.attr('checked', true).prop('checked', true);
            destSelect.trigger('change');
            $('#dest').val(history.dest_name);

            $('#destAirport').val(history.dest_airport_code);
        } else {
            destSelect.attr('checked', false).prop('checked', false);
            destSelect.trigger('change');
            $('#backCitySelectC').show();
        }
        this.container.hide();

        this.processFilters(history.filter);
    },

    processFilters: function (filters) {
        this.resetAllFilters();
        if (!filters) {
            return;
        }
        for (var filterGroup in filters) {
            var currentFilterGroup = filters[filterGroup];
            if (!currentFilterGroup) {
                continue;
            }
            for (var filter in currentFilterGroup) {
                var currentFilter = currentFilterGroup[filter];
                if (!currentFilter) {
                    continue;
                }
                var filterGroupName = filterGroup;
                if (this.isFilterGroupAnArray(filterGroupName)) {
                    filterGroupName += '[]';
                }
                this.activateFilter(filterGroupName, currentFilter);
            }
        }
    },

    isFilterGroupAnArray: function (filterGroupName) {
        return this.filterGroupsThatAreArrays.indexOf(filterGroupName) !== -1;
    },

    activateFilter: function (name, value) {
        if (name === 'customerAge') {
            $('#youngDriverC').prop('checked', false).trigger('change');
            $('#youngDriverAge').val(value);
        } else {
            var $elm = this.getFilterElement(name, value);
            $elm.attr('checked', true).prop('checked', true);
        }

        this.filterFromLastRequestsUsed = true;
    },

    buildFilterGroup: function (name, value) {
        var elm = document.createElement('input');
        elm.type = 'hidden';
        elm.name = name;
        elm.value = value;
        this.filterBox.append(elm);

        return this.getFilterElement(name, value);
    },

    getFilterElement: function (name, value) {
        var $elm = this.filterBox.find(
            'input[name="' + name + '"][value="' + value + '"]'
        );
        if ($elm.length) {
            return $elm;
        }

        return this.buildFilterGroup(name, value);
    },

    resetAllFilters: function () {
        this.filterBox
            .find('input[type="checkbox"]')
            .attr('checked', null)
            .prop('checked', null);
    },

    resetLastRequest: function () {
        this.filterFromLastRequestsUsed = false;
        this.resetAllFilters();
    },

    formatDate: function (date) {
        var thisday = date.substr(8, 2);
        var thismonth = date.substr(5, 2);
        var thisyear = date.substr(0, 4);
        return cmCarsCalendar.formatDate(
            thisday + '.' + thismonth + '.' + thisyear
        );
    },

    formatTime: function (date) {
        return date.substr(11, 5);
    },

    deleteLastSearch: function () {
        var track = new actionTracking({
            acTrAc: 'clicked_searchHistory',
            acTrLa: 'delete',
        });
        track.push();

        this.container.remove();
        /* eslint-disable-next-line jquery/no-ajax */
        $.post('/ajax/user/history/delete.php');
    },

    manageBackgroundImage: function (city, airportcode) {
        var key = airportcode;

        if (key in this.cache) {
            this.setBackgroundImage(
                this.cache[key].image_path,
                this.cache[key].minimal_price
            );
            return;
        }

        if (city) {
            var self = this;
            /* eslint-disable-next-line jquery/no-ajax */
            $.getJSON(
                '/suggest_json.php',
                'call=bySynonym&synonym=' + city + '&origin=stage',
                function (data, status, xhr) {
                    var suggestResult = data.suggest.results;
                    for (var i = 0; i < suggestResult.length; i++) {
                        if (suggestResult[i].code === airportcode) {
                            self.cache[key] = suggestResult[i];
                            self.setBackgroundImage(
                                suggestResult[i].image_path,
                                suggestResult[i].minimal_price
                            );
                            return;
                        }
                    }
                }
            );
        } else {
            this.setBackgroundImage(null, null);
        }
    },

    setBackgroundImage: function (replacement, price) {
        var eyecatcherGeneric = $('.eyecatcherGeneric');
        var img = $('.search-form-bg img');

        if (replacement) {
            var imageString = img.attr('src');

            if (imageString) {
                if (window.originalSrc !== '') {
                    img.attr(
                        'src',
                        imageString.replace(
                            /images\/.*\.jpg/g,
                            'images/' + replacement
                        )
                    );
                } else {
                    window.originalSrc = imageString;
                    img.attr(
                        'src',
                        imageString.replace(
                            /graphic\/image\/bg_stage.*\.jpg/g,
                            'files/images/' + replacement
                        )
                    );
                }
            }
        } else {
            if (window.originalSrc !== '') {
                img.attr('src', window.originalSrc);
                window.originalSrc = '';
            }
        }
        eyecatcherGeneric.show();
    },
};
lastSearchHistory.init();
